<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加配置</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="阶段"
            prop="phase"
            width="120"
            align="center"
          />
          <el-table-column
            label="消耗金额"
            prop="cost_price"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.cost_price }} 元
            </template>
          </el-table-column>
          <el-table-column
            label="赠送概率"
            prop="probability"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.probability }} %
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handlePcDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加配置' : '编辑配置'"
          :visible.sync="pcDialogVisible"
          width="500px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="阶段" prop="phase">
              <el-input
                v-model.number="pcForm.phase"
                placeholder="请输入阶段"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="消耗金额" prop="cost_price">
              <el-input
                v-model.number="pcForm.cost_price"
                placeholder="请输入消耗金额（元）"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="赠送概率" prop="probability">
              <el-input
                v-model.number="pcForm.probability"
                placeholder="请输入概率（百分比）"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加配置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="title">阶段：{{ item.phase }}</div>
                <div class="meta">ID:{{ item.id }}</div>
              </div>
            </div>
            <div class="card-body">
              <div>消耗金额：{{ item.cost_price }} 元</div>
              <div>赠送概率：{{ item.probability }} %</div>
              <div>创建时间：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                round
                @click.stop="handleMobileDel(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加配置' : '编辑配置'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="阶段" prop="phase">
              <el-input
                v-model.number="mobileForm.phase"
                placeholder="请输入阶段"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="消耗金额" prop="cost_price">
              <el-input
                v-model.number="mobileForm.cost_price"
                placeholder="消耗金额"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="赠送概率" prop="probability">
              <el-input
                v-model.number="mobileForm.probability"
                placeholder="赠送概率"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "GivePointConfig",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
      },
      // 表单验证
      addRules: {
        phase: [
          { required: true, message: "请输入阶段", trigger: "blur" },
          { type: "number", message: "阶段必须为数字", trigger: "blur" },
        ],
        cost_price: [
          { required: true, message: "请输入消耗金额", trigger: "blur" },
          { type: "number", message: "消耗金额必须为数字", trigger: "blur" },
        ],
        probability: [
          { required: true, message: "请输入赠送概率", trigger: "blur" },
          { type: "number", message: "概率必须为数字", trigger: "blur" },
        ],
      },

      // PC
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        give_point_id: "",
        phase: "",
        cost_price: "",
        probability: "",
      },

      // 移动端
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        give_point_id: "",
        phase: "",
        cost_price: "",
        probability: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ==================== 流水赠送配置列表 ====================
    getList() {
      this.loading = true;
      api.givePoint
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== PC 操作 ====================
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        give_point_id: row.id,
        phase: row.phase,
        cost_price: row.cost_price,
        probability: row.probability,
      };
      this.pcDialogVisible = true;
    },
    async handlePcDel(row) {
      try {
        await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        this.$message.info("已取消删除");
        return;
      }

      this.loading = true;
      api.givePoint
        .del({ give_point_id: row.id })
        .then((res) => {
          if (res.data.code == 1000) {
            this.getList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pcResetForm() {
      this.pcForm = {
        give_point_id: "",
        phase: "",
        cost_price: "",
        probability: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        let fn;
        if (this.pcDialogType == "add") {
          fn = api.givePoint.add;
        } else {
          fn = api.givePoint.edit;
        }

        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端 操作 ====================
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        give_point_id: row.id,
        phase: row.phase,
        cost_price: row.cost_price,
        probability: row.probability,
      };
      this.mobileDialogVisible = true;
    },
    async handleMobileDel(row) {
      try {
        await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        this.$message.info("已取消删除");
        return;
      }

      this.loading = true;
      api.givePoint
        .del({ give_point_id: row.id })
        .then((res) => {
          if (res.data.code == 1000) {
            this.getList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mobileResetForm() {
      this.mobileForm = {
        give_point_id: "",
        phase: "",
        cost_price: "",
        probability: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        let fn;
        if (this.mobileDialogType == "add") {
          fn = api.givePoint.add;
        } else {
          fn = api.givePoint.edit;
        }

        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 公共 ====================
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/givePoint/index.vue